<template>
  <boolean-setter v-bind="$attrs" :booleans="booleans" v-on="$listeners" />
</template>

<script>
import BooleanSetter from '@/components/DSE/BooleanSetter';
export default {
  components: {
    BooleanSetter
  },
  props: {},
  data() {
    return {
      booleans: ['readYN', 'createYN', 'executeYN', 'assignYN']
    };
  },
  computed: {},
  created() {}
};
</script>

<style lang="scss" scoped></style>
